class AccessDeniedController {
  constructor() {

  }
}

AccessDeniedController.$inject = [];

const accessDeniedComponent = {
  controller: AccessDeniedController,
  template: require('./accessDenied.template.html')
};

module.exports = accessDeniedComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/accessDenied/accessDenied.component.js